/**
 * 站外链接与上游署名 —— 单一事实来源。
 *
 * 本站是 `github.com/yezhiyi9670/sparks-notation`（Apache-2.0）的衍生作品：
 * 教程正文整份来自上游文档，界面与渲染核心也基于上游代码。许可证要求我们
 * 保留原作者的署名、随产物提供许可证副本与 NOTICE，并声明我们改过哪些地方。
 * 这三件事的落点是「引言页 · 关于本指南」「页脚」「站点根目录的 LICENSE / NOTICE」，
 * 而它们都要引用同一批字符串 —— 所以集中放这里，改一处即可。
 *
 * 许可证原文见仓库根的 `LICENSE`；`public/LICENSE`、`public/NOTICE` 是它的副本，
 * 更新 `LICENSE` / `NOTICE` 时必须一起同步（构建时不会自动拷贝）。
 */

/** 上游文档站 —— 未收录章节的「去原站看」指向这里 */
export const UPSTREAM_SITE = 'https://notation.sparkslab.art'

/** 上游仓库 */
export const UPSTREAM_REPO = 'https://github.com/yezhiyi9670/sparks-notation'

/** 上游署名 —— 与仓库根 `NOTICE` 里的那一行必须逐字一致 */
export const UPSTREAM_COPYRIGHT = 'Copyright 2023 yezhiyi9670'

/**
 * 许可证副本的地址。
 *
 * 写相对路径而不是 `/LICENSE`：产物是 `vite build --base=./` 出来的，要能放在
 * 任意子目录下（照 `examples.ts` 里那条规矩）。浏览器按当前文档地址解析，
 * 站点挂在 `/` 时得到 `/LICENSE`，挂在 `/nmn/` 时得到 `/nmn/LICENSE`，都对。
 */
export const LICENSE_URL = './LICENSE'

/** NOTICE 副本的地址 —— 同 `LICENSE_URL` */
export const NOTICE_URL = './NOTICE'

/**
 * ICP 备案号与备案管理方官网。
 *
 * 法规要求（《互联网信息服务管理办法》）备案号挂在首页页脚、并链接到
 * `beian.miit.gov.cn`。域名 manmantan.xyz 于 2026-10 备案通过（京ICP备2024081915号-6），
 * 站点同月从香港搬回上海 —— 这两件事是配套的：站点在大陆机房里托管，
 * 备案号才有意义，页脚也才敢把它放出来。
 */
export const ICP_FILING_NUMBER = '京ICP备2024081915号-6'
export const ICP_FILING_URL = 'https://beian.miit.gov.cn/'

/**
 * 公安备案（公网安备）号、备案平台官网与徽章图标。
 *
 * 法规要求（《计算机信息网络国际联网安全保护管理办法》）公网安备号挂在
 * 首页页脚、配公安徽章图标、链接到 `www.beian.gov.cn`。渲染上与 ICP 备案
 * 同排，按惯例公安备案排在前面（见 `SiteFooter.tsx` 的备案行）。
 *
 * 图标用相对路径，理由同 `LICENSE_URL`：产物是 `--base=./` 的，要能放在
 * 任意子目录下。文件本体是 `public/gonganbu.png` —— 它是仓库根
 * `logo/gonganbu.png` 的副本，与 LICENSE / NOTICE 一样要**手工同步**，
 * 构建不会自动拷贝（换了图只改 public/ 这份，logo/ 那份是源稿）。
 */
export const POLICE_FILING_NUMBER = '京公网安备11011402057545号'
export const POLICE_FILING_URL = 'https://www.beian.gov.cn/'
export const POLICE_FILING_ICON_URL = './gonganbu.png'
